import { Injectable } from '@angular/core';
import { OclGlobalInstructionTagService } from 'src/app/ocl/services/ocl-global-instruction-tag-service/ocl-global-instruction-tag.service';

@Injectable({
  providedIn: 'root',
})
export class OccGlobalInstructionTagService extends OclGlobalInstructionTagService {
  // tslint:disable:variable-name
  protected ParseGlobalInstructionTag = Parse.Object.extend('OCCGlobalInstructionTag');
  protected ParseGlobalInstruction = Parse.Object.extend('OCCGlobalInstruction');
  protected ParseTag = Parse.Object.extend('OCCTag');
  // tslint:enable
}
